import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter, Input, SimpleChanges, output } from '@angular/core';
import { lastValueFrom, Subject, Subscription, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { PosSalesService } from 'src/app/services/possalesservice';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { GeneralService } from 'src/app/services/general.service';
import Swal from 'sweetalert2';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { ANGULAR_MODULES, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import { CommonCalculatorService } from 'src/app/Shared/commonCalculators.service';

@Component({
  selector: 'app-pos-shipper-search',
  templateUrl: './pos-shipper-search.component.html',
  standalone: true,
  imports: [ANGULAR_MODULES, LoaderComponent, SYNCFUSION_MODULES],
  styleUrls: ['./pos-shipper-search.component.scss']
})
export class POSShipperSearchComponent implements OnInit, OnDestroy {
  public loaderIcon: Promise<boolean>;
  public data: any[] = [];
  private subscriptions: Subscription[] = [];

  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  @Output() shipperData = new EventEmitter<any>();
  @Output() closeShipperInfoModal = new EventEmitter<any>();
  @Input() shipperSearch;
  @Input() newForm;
  @Input() shipperId;
  imagePreviewUrl: string = './assets/images/NoPhoto.svg';
  shipperPhoto;
  public PhoneNumberMask: String = '(000)000-0000';

  pageNumber = 0;
  pageSize = 20;
  allRecords: any[] = [];
  searchField;
  searchValue;
  states = [];
  countries = [];
  shipperForm: FormGroup;
  private destroy$ = new Subject<void>();
  showStateDropDown;
  imageAddbtnText = "ADD"

  private phoneMaskValidator(control: AbstractControl): ValidationErrors | null {
    const rawValue = (control.value ?? '').toString();
    const digits = rawValue.replace(/\D/g, '');

    // Optional fields: validate only when user enters a value.
    if (!rawValue || digits.length === 0) {
      return null;
    }

    return digits.length === 10 ? null : { invalidPhone: true };
  }

  constructor(private posSalesService: PosSalesService,
    private toastr: ToastrService,
    private generalService: GeneralService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private formbuilder: FormBuilder,
    private commonCalculatorService: CommonCalculatorService
  ) {
    this.shipperForm = this.formbuilder.group({
      shippingId: [{ value: '', disabled: true }],
      marketShippingId : [{ value: '', disabled: true }], 
      firstName: ['', Validators.required],
      lastName: [''],
      address: [''],      
      city: [''],
      stateId: [''],
      countryId: [''],
      zip: [''],
      telephone: ['', [this.phoneMaskValidator.bind(this)]],
      cellPhone: ['', [this.phoneMaskValidator.bind(this)]],
      stateCode: ['']
    })
  }

  ngOnInit(): void {
    console.log("shipperSearch" + this.shipperSearch);
    this.loadAllShippers();
    this.loadCountries();
    this.loadStates(1);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("ngOnChanges triggered", changes);

    if (this.newForm) {
      this.shipperForm.reset();
      this.imagePreviewUrl  = './assets/images/NoPhoto.svg';
    }
    if (!this.shipperSearch && !this.newForm && this.shipperId) {
      this.getShipperInfo(this.shipperId);
    }
  }

  validateForm() {
    if (this.shipperForm.valid)
      return false;
    return true;
  }

  loadCountries(): void {
    this.generalService.getCountries()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res && res.length > 0) {
            this.countries = res;
          } else {
            // Default to US if empty
            this.countries = [{ Id: 1, Name: 'United States' }];
          }
        },
        error: (err) => {
          console.error('Failed to load countries', err);
          this.countries = [{ Id: 'US', Name: 'United States' }];
        }
      });
  }

  loadStates(countryId): void {
    this.generalService.getStates(countryId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.states = res;
        },
        error: (err) => {
          console.error('Failed to load US States', err);
        }
      });
  }

  async onCountryChange() {
    this.showStateDropDown = false;
    this.states = [];
    var countryId = this.shipperForm.get('countryId').value;
    this.states = await lastValueFrom(this.generalService.getStates(countryId));
    if (this.states.length == 0) {
      this.shipperForm.get('stateId').clearValidators();
      this.shipperForm.get('stateCode').setValidators(Validators.required);

    }
    else {
      this.showStateDropDown = true;
      this.shipperForm.get('stateId').setValidators(Validators.required);
      this.shipperForm.get('stateCode').clearValidators();
    }
    const countryIdNum = Number(countryId);
    this.commonCalculatorService.setZipCodeValidator(countryIdNum, this.shipperForm.get('zip'));
    this.shipperForm.get('zip').removeValidators(Validators.required);
    this.shipperForm.get('zip').updateValueAndValidity();
    this.shipperForm.get('stateId').updateValueAndValidity();
    this.shipperForm.get('stateCode').updateValueAndValidity();
  }

  zipCodeValidator() {
    let zipCodePattern;
    var countryId = this.shipperForm.value['countryId'];
    if (countryId == 1) {
      // US Zip Code validation
      zipCodePattern = /^\d{5}(-\d{4})?$/;
    } else if (countryId == 2) {
      // UK Postcode validation
      zipCodePattern = /^(GIR 0AA|[A-PR-UWYZa-pr-uwyz]([0-9]{1,2}|([A-HK-Ya-hk-y][0-9]([0-9ABEHMNPRVWXYabehmnprvwxy])?)|[0-9][A-HJKS-UWa-hjks-uw]) [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/;
    }
    else if (countryId == 6) {
      // Canada Postal Code validation (e.g., K1A 0B1)
      zipCodePattern = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    }
    const isValidZipcode = zipCodePattern.test(this.shipperForm.value['zip']);
    if (!isValidZipcode) {
      this.shipperForm.get('zip').setErrors({ invalidZipCode: true });
    } else {
      this.shipperForm.get('zip').setErrors(null);
    }
  }

  loadAllShippers(): void {
    this.loaderIcon = Promise.resolve(true);
    const vendorFilter = {
      PageNumber: this.pageNumber,
      PageSize: this.pageSize,
      SearchField: this.searchField,
      SearchValue: this.searchValue
    }
    this.subscriptions.push(
      this.posSalesService.GetPOSShippingList(vendorFilter)
        .subscribe((res: any) => {
          if (res && res.length > 0) {
            const mapped = res.map((el) => {
              const timestamp = new Date().getTime();
              return {
                ShippingId: el.ShippingId,
                MarketShippingId : el.MarketShippingId,
                FirstName: el.FirstName,
                LastName: el.LastName,
                Address: el.Address,
                City: el.City,
                StateId: el.StateId,
                CountryId: el.CountryId,
                Zip: el.Zip,
                Telephone: el.Telephone,
                CellPhone: el.CellPhone,
                ShipperPhoto: el.ShipperPhoto  ? el.ShipperPhoto + `?timestamp=${timestamp}` : ""
              };
            });

            this.data = [...this.data, ...mapped];

            this.pageNumber++;
          }
          this.loaderIcon = Promise.resolve(false);
        }, error => {
          this.loaderIcon = Promise.resolve(false);
          this.toastr.error('Error loading vendors');
        })
    );
  }

  onScroll(): void {
    const el = this.scrollContainer.nativeElement;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
      this.loadAllShippers(); // directly call API for next page
    }
  }

  resetAndLoad(): void {
    this.pageNumber = 0;
    this.data = [];
    this.imagePreviewUrl = './assets/images/NoPhoto.svg';
    this.loadAllShippers();
  }

  shipperDetails(item: any, event: MouseEvent): void {
    event.stopPropagation();
    this.shipperData.emit(item);
    this.closeShipperModal();
  }

  getShipperInfo(shipperId) {
    this.posSalesService.getShipperDetailsById(shipperId)
      .pipe().subscribe(details => {
        this.shipperData.emit(details);
        if (details) {
          const timestamp = new Date().getTime();
          this.imagePreviewUrl = details?.ShipperPhoto ? details?.ShipperPhoto + `?timestamp=${timestamp}` : './assets/images/NoPhoto.svg';
          if (details?.shipperPhoto) {
            this.shipperPhoto = {
              DeleteFlag: false
            }
          }
          this.shipperForm.patchValue({
            shippingId: details.ShippingId,
            marketShippingId : details.MarketShippingId,
            firstName: details.FirstName,
            lastName: details.LastName,
            address: details.Address,
            city: details.City,
            stateId: details.StateId,
            zip: details.Zip,
            telephone: details.Telephone,
            cellPhone: details.CellPhone,
            countryId: details.CountryId
          })
        }
      })
  }

  onBeforeOpen(args: any): void {
    if (!args || !args.target || !args.target.dataset || !args.target.dataset.content) {
      args.cancel = true;
    }
  }

  addImageClick() {
    const el = document.getElementById('ImageFileInput') as HTMLElement;
    if (el) {
      el.click();
    }
  }

  addImage(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];

      const allowedTypes = ['image/jpeg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        alert('Only JPG and PNG files are allowed.');
        input.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        if (file.type === 'image/jpeg') {
          // Already JPG → no conversion needed
          const base64Content = (reader.result as string).split(',')[1];
          this.imagePreviewUrl = reader.result as string;
          this.shipperPhoto = {
            ...this.shipperPhoto,
            UploadedshipperPhotoContent: base64Content,
            shipperPhotoName: file.name, // keep original name
            DeleteFlag: false,
          };
          input.value = '';
        } else {
          // Convert PNG → JPG
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d')!;
            canvas.width = img.width;
            canvas.height = img.height;

            ctx.drawImage(img, 0, 0);

            const jpgDataUrl = canvas.toDataURL('image/jpeg', 0.9); // JPG output
            const base64Content = jpgDataUrl.split(',')[1];
            this.imagePreviewUrl = jpgDataUrl;
            this.shipperPhoto = {
              ...this.shipperPhoto,
              UploadedshipperPhotoContent: base64Content,
              shipperPhotoName: file.name.replace(/\.[^/.]+$/, '') + '.jpg', // force .jpg extension
              DeleteFlag: false,
            };
            input.value = '';
          };
          img.src = reader.result as string;
        }
      };
      reader.readAsDataURL(file);
    }
  }

  get isDefaultImage(): boolean {
    return this.imagePreviewUrl === './assets/images/NoPhoto.svg';
  }

  get canRemoveImage(): boolean {
    if (!this.isDefaultImage && !this.shipperPhoto.DeleteFlag) {
      this.imageAddbtnText = "UPDATE"
      return true;
    } else {
      this.imageAddbtnText = "ADD"
      return false;
    }
  }

  removeImage() {
    this.shipperPhoto = {
      shipperPhotoName: '',
      UploadedshipperPhotoContent: null,
      DeleteFlag: true
    };
    this.imagePreviewUrl = './assets/images/NoPhoto.svg';
    const fileInput = document.getElementById('ImageFileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  saveShippingDetails() {
    var data = this.shipperForm.value;
    if (!data.FirstName) {
      data.shippingId = this.shipperForm.get('shippingId').value || 0;
      if (this.shipperPhoto) {
        var payload = {
          ImageName: this.shipperPhoto.shipperPhotoName || '',
          UploadedImageContent: this.shipperPhoto.UploadedshipperPhotoContent || null,
          DeleteFlag: this.shipperPhoto.DeleteFlag || false,
        };
      }
      data.ImageModel = payload;
      this.posSalesService.savePOSShippingDetails(data)
        .pipe()
        .subscribe(res => {
          this.toastr.success($localize`Shipper details saved successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
          this.shipperForm.reset();
          this.resetAndLoad();
          this.closeShipperInfoModal.emit();
          this.getShipperInfo(res.Id);
        });
    } else {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Please provide the neccessary info.`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
  }

  closeShipperModal() {
    this.closeShipperInfoModal.emit();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s?.unsubscribe());
  }
}
